import { withCache } from '@ngneat/cashew';

import { OUT_OF_STANDARD_CURRENCY } from '@cxc/core/enums';

import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { environment } from '@environments/environment';

import { platformAPI } from '@services/API/endpoints';

@Injectable({
  providedIn: 'root',
})
export class CurrenciesApi {
  private http = inject(HttpClient);
  getCurrencys(loaderOptIn: boolean | string = true) {
    const url = `${platformAPI.trusts().system.currencies}`;
    return this.http.get<OUT_OF_STANDARD_CURRENCY[]>(url, {
      headers: new HttpHeaders({
        'Loader-Opt-In': `${loaderOptIn}`,
        'Auth-Opt-In': 'true',
      }),
      // /system/currencies is a static catalogue; this was the only service
      // under services/API/trusts/** reading without the cache.
      context: withCache({
        ttl: environment.CACHE_LIFETIME!,
      }),
    });
  }

  /**
   * Probes whether a rate is currently resolvable for `source`->`target`.
   *
   * No `Loader-Opt-In` - run silently per option, not as a page-blocking
   * spinner. Not cached: availability can flip (source back up) within the
   * TTL that `getCurrencys` (a static catalogue) is fine caching.
   */
  getCurrencyRate(
    source: OUT_OF_STANDARD_CURRENCY,
    target: OUT_OF_STANDARD_CURRENCY
  ) {
    const params = new HttpParams()
      .set('source', source)
      .set('target', target);
    return this.http.get<{ rate: number }>(
      platformAPI.trusts().system.currencyRate,
      {
        params,
        headers: new HttpHeaders({
          'Loader-Opt-In': 'false',
          'Auth-Opt-In': 'true',
        }),
      }
    );
  }
}
